import React from "react";
import AliceCarousel2 from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { connect } from "react-redux";
import images from "../data/gallery.json";
import Lightbox from "react-images";
import { setActiveMenu } from "../actions";
import { Waypoint } from "react-waypoint";
import arrowLeft from "../images/arrow-left.png";
import arrowRight from "../images/arrow-right.png";
class Portfolio extends React.Component {
	state = {
		lightboxIsOpen: false,
		totalImages: Object.keys(images).length - 1,
		currentIndex: 0,
		currentImage: 0,
		responsive: {
			5: { items: 1 },
			400: { items: 2 },
			700: { items: 4 },
			800: { items: 4 },
			1024: { items: 4 }
		}
	};

	slideTo = (i) => this.setState({ currentIndex: i });

	onSlideChanged = (e) => {
		this.setState({ currentIndex: e.item });
	};

	slideNext = () => this.setState({ currentIndex: this.state.currentIndex + 1 });

	slidePrev = () => this.setState({ currentIndex: this.state.currentIndex - 1 });

	galleryItem(item, index) {
		return (
			<div
				onClick={() => {
					this.setState({
						currentImage: index,
						lightboxIsOpen: true
					});
				}}
				className="box-image"
				style={{
					backgroundImage: `url(${images[index].thumbnail})`
				}}>
				<i className="zoomIn material-icons pointer">zoom_in</i>
			</div>
		);
		// <Package index={index} store={this.props.store} />;
	}
	// const store = this.props.store.getState();

	imageClick = (e) => {
		console.log(e.clientX);
		const windowWidth = Math.floor(window.innerWidth);
		if (e.clientX <= windowWidth / 2) this.gotoPrevious();
		else this.gotoNext();
	};

	gotoPrevious = () => {
		const newCurrIndex = this.state.currentImage - 1 >= 0 ? this.state.currentImage - 1 : this.state.totalImages;
		this.setState({ currentImage: newCurrIndex, currentIndex: newCurrIndex });
	};

	gotoNext = () => {
		const newCurrIndex = this.state.currentImage + 1 <= this.state.totalImages ? this.state.currentImage + 1 : 0;
		this.setState({ currentImage: newCurrIndex, currentIndex: newCurrIndex });
	};

	closeLightbox = () => {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: false
		});
	};
	items = Object.keys(images).map(this.galleryItem.bind(this));
	render() {
		const { responsive, currentIndex } = this.state;
		const { langBase } = this.props;
		const title = langBase.portfolio_imgs_title;

		return (
			<div id="portfolio">
				<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(4)} />
				<h1 className="main-subtitle">
					<button onClick={() => this.slidePrev()}>
						<i className="material-icons pointer">chevron_left</i>
					</button>{" "}
					<span className="first">{langBase.portfolio.split(" ")[0]}</span> {langBase.portfolio.split(" ")[1]}
					<button onClick={() => this.slideNext()}>
						<i className="material-icons pointer">chevron_right</i>
					</button>
				</h1>

				{/* <p className="service_adv"> {lngBase.services_adv} </p> */}
				<div className="black">
					<div className="portfolio-title">
						<span className="firstLetter">{title[0]}</span>
						<span>{title.slice(1)}</span>
					</div>
					<AliceCarousel2
						// items={[<PortfolioImgs store={this.props.store} />]}
						className="myPhotos"
						items={this.items}
						dotsDisabled={true}
						swipeDisabled={false}
						buttonsDisabled={true}
						responsive={responsive}
						slideToIndex={currentIndex}
						onSlideChanged={this.onSlideChanged}
					/>
					<Lightbox
						currentImage={this.state.currentImage}
						images={Object.values(images)}
						isOpen={this.state.lightboxIsOpen}
						onClickPrev={this.gotoPrevious}
						onClickNext={this.gotoNext}
						onClose={this.closeLightbox}
						onClickImage={this.imageClick}
					/>
				</div>
				<div style={{display:"flex",
    justifyContent: "center"}}>
				<button onClick={() => this.slidePrev()}>
						<img src={arrowLeft} alt="Left arrow" width="50"/>
					</button>{" "}
					<span style={{
						fontSize: "26px",
						lineHeight: "50px",
						height: "50px",
						display: "inline-block",
						color: "#a3a3a3"
					}}>&nbsp;&nbsp;&nbsp;{langBase.navi}&nbsp;&nbsp;&nbsp;</span>
					<button onClick={() => this.slideNext()}>
						<img src={arrowRight} alt="Right arrow" width="50"/>
					</button>
				</div>
				<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(4)} />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {
	setActiveMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
